import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { ServiceUpdateRequest } from 'src/app/services/models/service/service.update.request.model'
import { ServiceCreateRequest } from 'src/app/services/models/service/service.create.request.model'
import {Response} from 'src/app/services/models/response.model'
import { Service } from './models/service/service.model';
import { ServiceSearchRequest } from './models/service/service.search.request.model';
import { GateService } from './models/service/gateservice.model';

@Injectable()
export class ServiceService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.service;
  }

  getAllService(): Observable<Response<Service[]>> {
    const url = `/GetAllService`;
    return this.get(url)
    .map(result => new Response<Service[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getServiceInfo(serviceid:number): Observable<Response<Service>> {
    const url = `/GetServiceInfo/`+serviceid;
    return this.get(url)
    .map(result => new Response<Service>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getGateServiceByService(serviceid:number): Observable<Response<GateService[]>> {
    const url = `/GetGateServiceByService/`+serviceid;
    return this.get(url)
    .map(result => new Response<GateService[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  searchService(data: ServiceSearchRequest): Observable<Response<Service[]>> {
    data.ServiceName = data.ServiceName.trim();
    return this.post(`/SearchService`, data, {})
    .map(result => new Response<Service[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  createService(serviceDetail: ServiceCreateRequest): Observable<Response<Service>> {
    serviceDetail.ListPrices = serviceDetail.ListPrices.trim();
    serviceDetail.ServiceCode = serviceDetail.ServiceCode.trim();
    serviceDetail.ServiceName = serviceDetail.ServiceName.trim();
    return this.post(`/CreateService`, serviceDetail, {})
    .map(result => new Response<Service>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  updateService(serviceDetail: ServiceUpdateRequest): Observable<Response<Service>> {
    serviceDetail.ListPrices = serviceDetail.ListPrices.trim();
    serviceDetail.ServiceName = serviceDetail.ServiceName.trim();
    return this.post(`/UpdateService`, serviceDetail, {})
    .map(result => new Response<Service>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}
